<template>
  <div class="trigger-wrapper" :class="{ 'bulk-trigger-wrapper': isBulk }">
    <div class="title-wrapper">
      <h1 class="title">{{ $t("create.step4.trigger.heading") }}</h1>
      <InterrogationMark
        v-if="isBulk"
        v-tippy="{
          arrow: true,
          placement: 'top',
          a11y: false,
          boundary: 'window',
        }"
        :content="$t('create.step4.trigger.tooltip')"
        class="interrogation-mark transition-tooltip"
      />
    </div>
    <ul
      class="trigger-segmentation"
      :class="{ 'bulk-trigger-segmentation': isBulk }"
    >
      <li class="trigger-list-item">
        <vidjet-radio-btn
          id="landing"
          v-model="trigger.type"
          name="trigger"
          :text="optionLabel('landing')"
          :val="TriggerType.landing"
          :checked="trigger.type === TriggerType.landing"
          @input="handleOption($event)"
        />
      </li>

      <li class="trigger-list-item">
        <vidjet-radio-btn
          id="exit"
          v-model="trigger.type"
          name="trigger"
          :text="optionLabel('exitIntent')"
          :val="TriggerType.exit"
          :checked="trigger.type === TriggerType.exit"
          @input="handleOption($event)"
        />
      </li>

      <li
        class="trigger-list-item"
        :class="{ 'make-flex': trigger.type === TriggerType.scroll }"
      >
        <vidjet-radio-btn
          id="scroll"
          v-model="trigger.type"
          name="trigger"
          :text="optionLabel('scroll')"
          :val="TriggerType.scroll"
          :checked="trigger.type === TriggerType.scroll"
          :force-flex="trigger.type === TriggerType.scroll"
          @input="handleOption($event)"
        />
        <span
          v-show="trigger.type === TriggerType.scroll"
          class="trigger-option-text"
        >
          {{ $t("create.step4.trigger.distanceScrolled") }}
          <input
            v-model="trigger.option"
            class="number-input trigger-input"
            type="number"
            placeholder="20"
            min="1"
            max="99"
            @change="handleOption($event)"
          />
          %.
        </span>
      </li>

      <li
        class="trigger-list-item"
        :class="{ 'make-flex': trigger.type === TriggerType.delay }"
      >
        <vidjet-radio-btn
          id="delay"
          v-model="trigger.type"
          name="trigger"
          :text="optionLabel('delay')"
          :val="TriggerType.delay"
          :checked="trigger.type === TriggerType.delay"
          :force-flex="trigger.type === TriggerType.delay"
          @input="handleOption($event)"
        />
        <span
          v-show="trigger.type === TriggerType.delay"
          class="trigger-option-text"
        >
          {{ $t("create.step4.trigger.delayEquals") }}
          <input
            v-model="trigger.option"
            class="number-input trigger-input"
            type="number"
            placeholder="5"
            min="1"
            @change="handleOption($event)"
          />
          {{ $t("create.step4.trigger.seconds") }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import enums from "@/enums";
import InterrogationMark from "@/assets/svg/settings/interrogation-mark.svg?inline";
import VidjetRadioBtn from "../shared/Vidjet-radio-btn.vue";

const { TriggerType } = enums;
export default {
  name: "TriggerSegmentation",
  components: { VidjetRadioBtn, InterrogationMark },
  props: {
    value: {
      type: Object,
      default: null,
    },
    isBulk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TriggerType,
      scrollOption: null,
      delayOption: null,
    };
  },
  computed: {
    trigger() {
      if (!this.value) return { type: 0 };
      return this.value;
    },
  },
  methods: {
    optionLabel(key) {
      const suffix = this.isBulk ? "Short" : "";
      return this.$t(`create.step4.trigger.options.${key}${suffix}`);
    },
    handleOption() {
      if (this.trigger.type === TriggerType.scroll) {
        event.target.value =
          parseInt(event.target.value) > 99
            ? 99
            : parseInt(event.target.value) <= 0
            ? 1
            : event.target.value;
        this.scrollOption = parseInt(event.target.value);
      } else if (this.trigger.type === TriggerType.delay) {
        event.target.value =
          parseInt(event.target.value) <= 0 ? 1 : event.target.value;
        this.delayOption = parseInt(event.target.value);
      } else {
        this.trigger.option = null;
      }

      this.trigger.option = parseInt(event.target.value);
      return this.$emit("input", this.trigger);
    },
  },
};
</script>

<style lang="scss" scoped>
.trigger-wrapper {
  border: 1px solid #dadada;
  border-radius: 4px;
  padding: 16px;
  .title-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .title {
    @include base-font;
    @include font-normal;
    margin-bottom: 16px;
  }
}
.bulk-trigger-wrapper {
  box-sizing: border-box;
  width: 90%;
  background: white;
  border-radius: 10px;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 16px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 40px;
  .title {
    margin-bottom: 0;
    text-align: center;
    font-weight: 500;
  }
}
.trigger-segmentation {
  .trigger-list-item {
    .trigger-option-text {
      margin-top: 5px;
      margin-left: 18px;
      @include base-font;
      @include font-smallest;
      font-weight: 500;
      display: flex;
    }
    .trigger-input {
      margin: -2px 7px;
    }
  }
}
.bulk-trigger-segmentation {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  .trigger-list-item {
    .trigger-option-text {
      margin-top: 5px;
      margin-left: 0;
      @include base-font;
      @include font-smallest;
      font-weight: 500;
      display: flex;
    }
    .trigger-input {
      margin: -2px 7px;
    }
  }
}
.interrogation-mark {
  border: solid 1px #585858;
  border-radius: 50%;
  transform: scale(1.1);
}
</style>
